<!-- @format -->

<template>
  <div class="content h-screen">
    <div class="flex py-4 px-4 bg-white items-center subscription-register-header">
      <img :src="require('@/assets/images/logo/shachihata-logo.svg')" class="h-16"  alt="Shachihata"/>
    </div>
    <div id="subscription-register" class="flex bg-img vx-row no-gutter items-center justify-center">
      <vx-card title="配信設定変更の手順" class="w-full lg:w-1/2 xl:w-1/3 py-10">
        <p class="text-left">1．メールアドレスを入力して認証してください。</p>
        <p class="text-left">2．入力したメールアドレス宛に設定変更のメールが送信されます。</p>
        <p class="text-left">3．メールからフォームに入り、設定を行ってください。</p>
        <div class="input-container w-full text-center">
          <vs-input v-validate="'required|email'" name="email" @keyup.enter="onRegisterSubscription" class="inline-block w-4/5 text-left" label-placeholder="メールアドレスを入力" v-model="email" />
          <vs-button class="ml-6 mt-4" :disabled="!email || !isValid" color="#1665b2" @click="onRegisterSubscription">認証</vs-button>
        </div>
        <p class="text-sm text-danger" v-show="!isValid">メールアドレスには正しい形式のメールアドレスを指定してください</p>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SubscriptionRegister',
  data() {
    return {
      email: ''
    }
  },
  computed: {
    isValid() {
      return !this.email || !this.errors.any()
    },
    ...mapGetters({
      subscriptions: 'subscriptions/getSubscriptions'
    })
  },
  methods: {
    ...mapActions({
      registerSubscription: 'subscriptions/registerSubscription'
    }),
    async onRegisterSubscription() {
      await this.registerSubscription({ email: this.email })
    }
  }
}
</script>

<style lang="scss" scoped>
  .subscription-register-header {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14);
  }
  #subscription-register {
    height: calc(100% - 84px);
  }
</style>
